export const Previous = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
            <path
                d="M8.75876 13.907L3.35759 8.40958L8.75876 2.91219C9.30166 2.35962 9.30166 1.467 8.75876 0.91443C8.21586 0.361857 7.33886 0.361857 6.79596 0.91443L0.406443 7.41779C-0.136458 7.97036 -0.136458 8.86298 0.406443 9.41555L6.79596 15.9189C7.33886 16.4715 8.21586 16.4715 8.75876 15.9189C9.28774 15.3663 9.30166 14.4595 8.75876 13.907Z"
                fill="#575757"
            />
        </svg>
    );
};
